import React, { useState } from "react";
import { CompletedCheckmark } from "../../icons/CompletedCheckmark";

export const Heading = ({
  title,
  completed,
  completedAttr,
  isActive,
  onClick,
  setState,
}) => {
  const handleClick = () => {
    onClick();
    setState((prev) => ({
      ...prev,
      [completedAttr]: false,
    }));
  };
  return (
    <div
      onClick={handleClick}
      className={`styling-wrap__heading ${isActive ? "active" : ""} ${
        completed ? "completed" : ""
      }`}
    >
      <p class="poppins-16-400">
        <span class="styling-wrap__check">
          <CompletedCheckmark />
        </span>
        {title}
      </p>
    </div>
  );
};
